export const WINDOWS_SCROLLBAR_WIDTH = "17px"

export const storyblokHorizontalGutterClasses = `px-gutter-xs sm:px-gutter-sm md:px-gutter-md lg:px-gutter-lg xl:px-gutter-xl 4k:px-gutter-4k`
